import { render, staticRenderFns } from "./OnlineConsult.vue?vue&type=template&id=9f1d9228&scoped=true"
import script from "./OnlineConsult.vue?vue&type=script&lang=js"
export * from "./OnlineConsult.vue?vue&type=script&lang=js"
import style0 from "./OnlineConsult.vue?vue&type=style&index=0&id=9f1d9228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1d9228",
  null
  
)

export default component.exports